import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const goldFDCloseConfirmApi = createAsyncThunk(
  "goldFDCloseConfirm",
  async (transactionId, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `/fd/preorderCloseCalculate/${transactionId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const goldFDCloseConfirmSlice = createSlice({
  name: "goldFDCloseConfirm",
  initialState: {
    data: [],
    errors: [],
    status: "idle",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(goldFDCloseConfirmApi.pending, (state) => {
        state.status = "loading";
        state.errors = [];
      })
      .addCase(goldFDCloseConfirmApi.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = "idle";
      })
      .addCase(goldFDCloseConfirmApi.rejected, (state, action) => {
        state.errors.push(action.payload);
        state.status = "idle";
      });
  },
});

export default goldFDCloseConfirmSlice.reducer;
